module.exports = __webpack_public_path__ + "img/_b-dagger_.8e0d8a3c.svg";